<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <div class="page-title-row flex flex-align-center gap-sm mb-md">
    <app-back-button [ariaLabel]="'settings.back' | translate" />
    <h2>{{ 'settings.organization.title' | translate }}</h2>
  </div>

  <div class="scrollable-content">
    <app-card>
      <app-card-content>
        <div class="setting-item">
          <div class="setting-header setting-header--full-width flex gap-md flex-grow">
            <div>
              <h4>{{ 'settings.organization.nameLabel' | translate }}</h4>
              <p class="setting-value">{{ organizationName() || ('settings.organization.noName' | translate) }}</p>
            </div>
            @if (userRole() === 'owner') {
            <app-button variant="outlined" (click)="showRenameOrganization()" [disabled]="!canUseNetwork()"
              data-testid="rename-organization-button">
              <app-icon name="pen" />
              <span>{{ 'settings.organization.rename' | translate }}</span>
            </app-button>
            }
          </div>
          @if (!canUseNetwork()) {
          <p class="setting-description muted">
            {{ 'settings.organization.renameOnlineOnly' | translate }}
          </p>
          }
        </div>
      </app-card-content>
    </app-card>

    <h3 class="switch-section-title">{{ 'settings.organization.switchSectionTitle' | translate }}</h3>
    <app-organization-list />
  </div>
</div>

@if (showRenameDialog()) {
<app-modal-dialog (backdropClick)="cancelRename()">
  <div header>
    <div class="modal-title-row">
      <div class="heading-md">{{ 'settings.organization.renameDialog.title' | translate }}</div>
    </div>
  </div>

  <div content>
    <p class="modal-description">
      {{ 'settings.organization.renameDialog.description' | translate }}
    </p>

    <app-form-field [label]="'settings.organization.renameDialog.nameLabel' | translate">
      <app-input>
        <input type="text" [(ngModel)]="newOrganizationName"
          [placeholder]="'settings.organization.renameDialog.namePlaceholder' | translate"
          data-testid="new-organization-name-input" (keyup.enter)="confirmRename()" required />
      </app-input>
    </app-form-field>
  </div>

  <div footer>
    <app-button variant="text" (click)="cancelRename()" [disabled]="renamingOrganization()"
      data-testid="cancel-rename-button">
      {{ 'settings.organization.renameDialog.cancel' | translate }}
    </app-button>
    <app-button variant="filled" color="primary" (click)="confirmRename()"
      [disabled]="renamingOrganization() || !newOrganizationName().trim() || !organizationNameChanged()"
      data-testid="confirm-rename-button">
      @if (renamingOrganization()) {
      <span>{{ 'settings.organization.renameDialog.saving' | translate }}</span>
      } @else {
      <span>{{ 'settings.organization.renameDialog.save' | translate }}</span>
      }
    </app-button>
  </div>
</app-modal-dialog>
}
